import React from 'react';

import { condensateOpenHours } from 'shipping/utils';

type Props = {
  openingHours: string[][][] | null | undefined;
};

/**
 * Renders parcel-shop opening hours as a compact two-column table with merged equal days
 * (Mo-Fr 8-18, Sa closed, ...). Closed days are dimmed gray.
 */
function OpeningHoursTable({ openingHours }: Props) {
  if (!openingHours || openingHours.length === 0) return null;

  const items = condensateOpenHours({
    work_hours: Object.fromEntries(openingHours.map((p, i) => [i, p])),
  } as any);

  if (items.length === 0) return null;

  return (
    <div className="inline-flex flex-col rounded-md bg-gray-50 px-3 py-2 text-xs text-gray-600">
      {items.map((item) => {
        const isClosed = item.openHours === gettext('closed');
        return (
          <div key={item.day} className="flex gap-3">
            <span className="w-12 whitespace-nowrap font-medium text-gray-700">{item.day}</span>
            <span className={`tabular-nums ${isClosed ? 'text-gray-400' : 'text-gray-600'}`}>{item.openHours}</span>
          </div>
        );
      })}
    </div>
  );
}

export default OpeningHoursTable;
